<template>
  <div class="package section">
    <header class="field">
      <h1 class="title is-1">{{ pkg.name }}</h1>
    </header>
    <section>
      <table class="field table is-narrow">
        <thead>
          <tr>
            <th>Homepage</th>
            <th>Installed Packages</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <a :href="homepage.href" v-if="homepage">{{ homepage.url.hostname }}</a>
              <em v-else>None</em>
            </td>
            <td>
              <ul>
                <li v-for="name in pkg.packages" :key="name">{{ name }}</li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>

      <pre class="field">{{ pkg.copyright }}</pre>
    </section>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        packageName: null
      }
    },
    computed: {
      pkg () {
        return Array.prototype.find.call(
          this.$licenseData.packages,
          pkg => pkg.name === this.packageName
        )
      },
      homepage () {
        if (!this.pkg.homepage_url) return null
        const url = new URL(this.pkg.homepage_url)
        return {
          href: this.pkg.homepage_url,
          url
        }
      }
    },
    created () {
      this.packageName = this.$route.params.package
    },
    beforeRouteUpdate (to, from, next) {
      this.packageName = to.params.package
      next()
    }
  }
</script>
